import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=63b74e54&scoped=true&"
import script from "./Categories.vue?vue&type=script&lang=ts&"
export * from "./Categories.vue?vue&type=script&lang=ts&"
import style0 from "./Categories.vue?vue&type=style&index=0&id=63b74e54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b74e54",
  null
  
)

export default component.exports